import Vue from "vue";
import Vuetify from "vuetify/lib";
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    // dark: localStorage.getItem('dark-theme') === 'false', // getItem возвращает строку,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#000",
        secondary: "",
        accent: "#000",
        error: "#fc0004",
        red: "#fc0004",
        info: "#2196F3",
        success: "#48a300",
        warning: "#e2be00",
        white: "#fff",
        grey: "#fafafa" 
      },
    }
  }
});

